import Button from "components/common/Button";
import TextFieldCustom from "components/TextFieldCustom";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { displayNotification, sendAPIRequest } from "helpers";
import { useSelector } from "react-redux";


const MissionLeaveModal = ({ isShow, initModal, reloadData, missionId }) => {

    const [reason, setReason] = useState('');
    const { t } = useTranslation();
    const authData = useSelector((s) => s.auth.data);

    const navigate = useNavigate();

    const handleLeaveMission = () => {
        handleSave();
    }

    const handleClose = () => {
        initModal();
        setReason('');
    }

    const handleSave = async () => {
        try {
            const req = await sendAPIRequest(`/api/pvsa/mission-expert/leave-mission?mission_id=${missionId}&user_id=${authData.id}`, 'POST', { reason: reason });
            const res = await req.json();

            if (res.success) {
                displayNotification('success', t("-1", "Successfully saved data"));
                reloadData(reason);
                setReason(''); 
                navigate('/portal/mission-cc');
            } else {
                displayNotification('error', `${t("-1", "Error saving data")} [B]`);
            }
        } catch (e) {
            console.error(e);
            displayNotification('error', `${t("-1", "Error saving data")} [F]`);
        }
    };

    return (
        <React.Fragment>
            <Modal show={isShow} size="lg">
                <Modal.Header closeButton onClick={() => initModal()}>
                    <Modal.Title><h1>Leave Mission</h1></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TextFieldCustom
                        label={"Reason"}
                        fullWidth
                        multiline={true}
                        minRows={4}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        size="small"
                        sx={{
                            marginTop: "6px",
                            marginBottom: "6px",
                            backgroundColor: "white",
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={handleLeaveMission}
                    >
                        Leave
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
}

MissionLeaveModal.defaultProps = {
    isShow: false,
    initModal: () => { },
    reloadData: () => { },
};

export default MissionLeaveModal;